const payment = `
    amount
    created
    date
    documentId
    documentType
    externalReference {
        type
    }
    id
    sentDate
`;

export default payment;
